module.exports = __webpack_public_path__ + "static/media/hero.cb45efca.png";